import { Message } from "../../domain/entities/message";
import { httpClient } from "../axios/axios-api";
import { Tripsheet } from "domain/entities/tripsheet";
import { ITripsheetRepository } from "domain/contracts/tripsheet.contract";
import { TripsheetInputFilter } from "domain/models/tripsheet-input-filter";

class TripsheetRepository implements ITripsheetRepository {
  async create(input: Tripsheet): Promise<Message<Tripsheet[]>> {
    const response = await httpClient.post(`/tripsheet/setting`, {
      data: input,
    });
    return response.data;
  }

  async getAll(filter: TripsheetInputFilter): Promise<Message<Tripsheet[]>> {
    const response = await httpClient.get(`/tripsheet`, { params: filter });
    return response.data;
  }

  async update(input: Tripsheet): Promise<Message<boolean>> {
    const response = await httpClient.put(`/tripsheet/${input.id}`, {
      data: input,
    });
    return response.data;
  }

  async getById(id: string): Promise<Message<Tripsheet>> {
    const response = await httpClient.get(`/tripsheet/${id}`);
    return response.data;
  }
}

export default new TripsheetRepository();
